<template>
  <div>
    <a-table size="middle" :scroll="{ x: 1200 }" :expand-icon-column-index="1" :pagination="false" :columns="columns" :data-source="dataSource" row-key="id" :loading="loading">
      <span slot="customerTitle" slot-scope="text, record">
        <span class="story-edit">
          <a-tooltip placement="top" :title="record.title">
            <a class="custom-link" :href="link(record)" target="_blank">{{ record.title }}</a>
          </a-tooltip>
        </span>
      </span>
      <span slot="status" slot-scope="text, record">
        <span class="edit-status">
          <a-badge :status="storyStatus[record.status].status" :text="storyStatus[record.status].label" />
        </span>
      </span>
      <span slot="priority" slot-scope="text, record">
        <span>{{ record.priority || '--' }}</span>
      </span>
      <span slot="type" slot-scope="text, record">
        <a-badge v-if="storyTypes[record.requirement_type]" :color="storyTypes[record.requirement_type].color" :text="storyTypes[record.requirement_type].label" />
        <span v-else>--</span>
      </span>
      <span slot="isReview" slot-scope="text, record">
        <a-tag v-if="storyReviews[record.is_review]" :color="storyReviews[record.is_review].color">{{ storyReviews[record.is_review].label }}</a-tag>
        <span>--</span>
      </span>
    </a-table>
  </div>
</template>

<script>
import { storyStatus, storyTypes, storyReviews, taskStatus, taskPrioritys } from '@/utils/dictionary';

const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    width: 90,
    customRender: (_text, _row) => {
      return (_row.item_type === 'task' ? 'TS-' : 'PR-') + _text;
    }
  },
  {
    title: '需求标题',
    dataIndex: 'title',
    key: 'title',
    ellipsis: true,
    width: 480,
    scopedSlots: { customRender: 'customerTitle' }
  },
  {
    title: '状态',
    dataIndex: 'status',
    key: 'status',
    width: 140,
    scopedSlots: { customRender: 'status' }
  },
  {
    title: '负责人',
    width: 120,
    ellipsis: true,
    customRender: (_, _row) => {
      return _row.handlers && _row.handlers.length > 0 ? _row.handlers.map(user => user.nickname).join('; ') : '--';
    }
  },
  {
    title: '产品',
    width: 120,
    ellipsis: true,
    customRender: (_, _row) => {
      return _row.pm && _row.pm.length > 0 ? _row.pm.map(user => user.nickname).join('; ') : '--';
    }
  },
  {
    title: '质量',
    width: 120,
    ellipsis: true,
    customRender: (_, _row) => {
      return _row.qa && _row.qa.length > 0 ? _row.qa.map(user => user.nickname).join('; ') : '--';
    }
  },
  {
    title: '创建人',
    dataIndex: 'creator',
    key: 'creator',
    width: 80,
    customRender: text => {
      return text.nickname;
    }
  },
  {
    title: '创建时间',
    dataIndex: 'created_time',
    key: 'created_time',
    width: 168
  },
  {
    title: '更新时间',
    dataIndex: 'updated_time',
    key: 'updated_time',
    width: 168
  }
];
export default {
  props: {
    dataSource: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      loading: false,
      columns,
      storyStatus,
      storyTypes,
      storyReviews,
      taskStatus,
      taskPrioritys
    };
  },
  computed: {
    link() {
      return record => {
        return this.$router.resolve({
          name: 'page:project:story:detail',
          params: { project_id: record.project_id },
          query: { storyId: record.id }
        }).href;
      };
    },
    handlers() {
      return record => {
        return record.handlers || null;
      };
    },
    pm() {
      return record => {
        return record.pm || null;
      };
    },
    om() {
      return record => {
        return record.operators || null;
      };
    }
  },
  watch: {
    data: {
      immediate: true,
      handler(val) {
        this.tableData = val;
      }
    }
  }
};
</script>
